import { v4 as uuidv4 } from 'uuid';

const ISSUER_ID = 'https://sdsconsortium.com';
const BASE_URL = 'https://sdsconsortium.com/awards';

export function buildCredential({ recipientName, recipientEmail, badgeType, year, message }) {
    const id = uuidv4();
    return {
        '@context': [
            'https://www.w3.org/2018/credentials/v1',
            'https://purl.imsglobal.org/spec/ob/v3p0/context-3.0.2.json',
        ],
        id: `${BASE_URL}/credentials/${id}`,
        type: ['VerifiableCredential', 'OpenBadgeCredential'],
        issuer: {
            id: ISSUER_ID,
            type: ['Profile'],
            name: 'SDS Industry Consortium',
            url: 'https://sdsconsortium.com',
            email: 'info@sdsconsortium.com',
        },
        issuanceDate: new Date().toISOString(),
        name: badgeType.name,
        credentialSubject: {
            id: `mailto:${recipientEmail}`,
            type: ['AchievementSubject'],
            name: recipientName,
            achievement: {
                id: `${BASE_URL}/achievements/${badgeType.id}`,
                type: ['Achievement'],
                name: badgeType.name,
                description: badgeType.description,
                criteria: { narrative: badgeType.criteria },
                image: {
                    id: `${BASE_URL}/badge-images/${badgeType.id}.png`,
                    type: 'Image',
                },
            },
        },
        verificationUrl: `${BASE_URL}/verify/${id}`,
        _meta: { id, badgeTypeId: badgeType.id, recipientName, recipientEmail, year, message },
    };
}
